import { ContextStore } from "@utils/context/ContextStore";
import { useContext } from "react";

const useContextStore = (): ContextStore => useContext(ContextStore);

export default useContextStore;
